import { all, fork } from "redux-saga/effects";
import loginSagas from "./components/Login/loginSagas";
import forgotPasswordSagas from "./components/ForgotPassword/forgotPasswordSagas";
import resetPasswordSagas from "./components/ResetPassword/resetPasswordSagas";
import dashboardSagas from "./components/Dashboard/dashboardSagas";
import tableSagas from "./components/Table/tableSagas";
import subscriptionSagas from "./components/Subscription/subscriptionSagas";
import integrationsSaga from "./components/Integrations/integrationSagas";

/**
 * rootSaga
 */
export default function* root() {
  yield all([
    fork(loginSagas),
    fork(forgotPasswordSagas),
    fork(resetPasswordSagas),
    fork(dashboardSagas),
    fork(tableSagas),
    fork(subscriptionSagas),
    fork(integrationsSaga)
  ]);
}
